import React, { useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import AdminSideBar from '../../Containers/AdminSideBar'
import TeacherContainer from '../../Containers/TeacherContainer'
import { getAccessProperty } from './../../Service/properties'
import TeacherRightSideContent from './../../block/TeacherRightSideContent/index'
import { teacherProperty } from './../../store/teacherProperty'
import { useTranslation } from 'react-i18next'

export default function TeachersPage() {
	const getAccessPropties = async id => {
		const result = await getAccessProperty(id)
		teacherProperty.newAccessProperty(result)
	}

	useEffect(() => {
		getAccessPropties(2)
	}, [])
	const { t } = useTranslation()
	return (
		<div className='ContentsWrapper'>
			<Helmet>
				<meta charSet='utf-8' />
				<title>
					{t('st:head.menu')} | {t('head.appTitle')}
				</title>
			</Helmet>
			<AdminSideBar />
			<TeacherContainer />
			<TeacherRightSideContent />
		</div>
	)
}
